import type { Action } from "redux";

export type BuiltToNotBuiltConfirmationDialogDismissedEvent = Action<typeof BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_DISMISSED>

export const builtToNotBuiltConfirmationDialogDismissed = (): BuiltToNotBuiltConfirmationDialogDismissedEvent => ({
  type: BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_DISMISSED
});

export const BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_DISMISSED = "built_to_not_built_confirmation_dialog_dismissed";
